import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from '../../shared/api.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-solicitud-recibida',
  templateUrl: './solicitud-recibida.component.html',
  styleUrls: ['./solicitud-recibida.component.scss']
})
export class SolicitudRecibidaComponent implements OnInit {

  @Input() codigo: any;
  @Input() codigoMensaje: any;
  @Input() plazo: any;
  @Input() mensaje: any;
  @Input() solicitud: any;

  // Inputs para llamado a la API de constancia
  @Input() nCliente: string = '';
  @Input() nAviso: string = '';

  // Constancia en base64 desde el servicio RU2
  @Input() constanciaBase64: string = '';

  constanciaDisponible = false;
  descargandoConstancia = false;
  errorConstancia = false;

  constructor(
    private apiService: ApiService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.verificarConstanciaDisponible();
  }

  verificarConstanciaDisponible() {
    if (this.nCliente && this.nAviso) {
      this.constanciaDisponible = true;
      console.log('Constancia disponible para aviso:', this.nAviso);
    } else {
      this.constanciaDisponible = false;
    }
  }

  imprimirConstancia() {
    window.print();
  }

  descargarConstancia() {
    if (!this.nCliente || !this.nAviso) {
      console.error('Faltan datos necesarios para obtener la constancia');
      this.errorConstancia = true;
      return;
    }

    this.descargandoConstancia = true;
    this.errorConstancia = false;
    this.spinner.show();

    this.apiService.obtenerConstanciaReclamo(this.nCliente, this.nAviso).subscribe(
      (response) => {
        console.log('Respuesta obtener constancia:', response);
        if (response && response.ConstanciaReclamante) {
          this.convertirYDescargarPDF(response.ConstanciaReclamante, `Constancia_${this.nAviso}.pdf`);
        } else {
          console.error('No se recibió el documento en formato BASE64');
          this.errorConstancia = true;
        }
        this.descargandoConstancia = false;
        this.spinner.hide();
      },
      (error) => {
        console.error('Error al obtener constancia:', error);
        this.errorConstancia = true;
        this.descargandoConstancia = false;
        this.spinner.hide();
      }
    );
  }

  abrirConstancia() {
    if (!this.nCliente || !this.nAviso) {
      console.error('Faltan datos necesarios para obtener la constancia');
      this.errorConstancia = true;
      return;
    }

    this.descargandoConstancia = true;
    this.errorConstancia = false;
    this.spinner.show();

    this.apiService.obtenerConstanciaReclamo(this.nCliente, this.nAviso).subscribe(
      (response) => {
        console.log('Respuesta obtener constancia:', response);
        if (response && response.ConstanciaReclamante) {
          this.convertirYAbrirPDF(response.ConstanciaReclamante);
        } else {
          console.error('No se recibió el documento en formato BASE64');
          this.errorConstancia = true;
        }
        this.descargandoConstancia = false;
        this.spinner.hide();
      },
      (error) => {
        console.error('Error al obtener constancia:', error);
        this.errorConstancia = true;
        this.descargandoConstancia = false;
        this.spinner.hide();
      }
    );
  }

  convertirYDescargarPDF(base64String: string, nombreArchivo: string) {
    try {
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = nombreArchivo;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      console.log('PDF descargado exitosamente');
    } catch (error) {
      console.error('Error al convertir y descargar PDF:', error);
      this.errorConstancia = true;
    }
  }

  convertirYAbrirPDF(base64String: string) {
    try {
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
      console.log('PDF abierto exitosamente');
    } catch (error) {
      console.error('Error al convertir y abrir PDF:', error);
      this.errorConstancia = true;
    }
  }

  tieneConstanciaDisponible(): boolean {
    return this.constanciaBase64 !== null && this.constanciaBase64 !== undefined && this.constanciaBase64 !== '';
  }

}
